// Client for the Worker's /v1/rooms API (apps/worker/src/rooms.ts): live
// handoff rooms (docs/adr/0010). Errors are SecretsApiError, like secrets.

import type { CreateRoomRequest, CreateRoomResponse, RoomMetadata, RoomRole } from '@sss/types';
import { API_BASE_URL } from './config';
import { json, request } from './secretsApi';

const path = (id: string, suffix = '') => `/v1/rooms/${encodeURIComponent(id)}${suffix}`;

export const createRoom = (input: CreateRoomRequest, base?: string) => request<CreateRoomResponse>('/v1/rooms', json('POST', input), base);

/** Whether the room can be joined. Never joins it. */
export const getRoom = (id: string, base?: string) => request<RoomMetadata>(path(id), {}, base);

/**
 * The room's WebSocket URL. The sender proves its seat in the first message,
 * never in this URL. `pageOrigin` resolves a same-origin API (dev, where Vite
 * proxies /v1/rooms).
 */
export const roomSocketUrl = (id: string, role: RoomRole, pageOrigin: string, base = API_BASE_URL): string => {
  const url = new URL(`${base || pageOrigin}${path(id, '/socket')}`);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.searchParams.set('role', role);
  return url.toString();
};
